import React from 'react';
import { File } from 'types/policyService';
import InfoMessage from 'components/common/download-files/InfoMessage';

export const ZIP_MANAGEMENT_ONLY_MESSAGE = 'Available only to Sponsor Management users';

export const getZipAvailabilityNote = (zip?: Pick<File, 'id' | 'availability'> | null): React.ReactElement | null => {
  if (!zip?.id) {
    return null;
  }

  switch (zip.availability) {
    case 'CELTIC':
      return <InfoMessage message={ZIP_MANAGEMENT_ONLY_MESSAGE} />;
    case 'BROKER':
    default:
      return null;
  }
};
